<template>
  <div id="main-content">
    <PanelCard :home-show-data="homeShowData"></PanelCard>
    <a-card title="产品汇总"
            style="width: 100%;flex: 1;overflow-y: hidden;border-radius: 5px;"
            :bodyStyle="{padding:'0',height: 'calc(100% - 65px)'}">
      <div slot="extra" >
        <a-select v-model="product" style="width: 240px" allowClear
                  mode="multiple" :maxTagCount="1" placeholder="请选择产品"
                  optionFilterProp="label"
                  @change="changeProduct()">
          <a-select-option v-for="productItem in $store.getters.getAppAll"
                           :label="productItem.app_name"
                           :value="productItem.app_id"
                           :key="productItem.app_id">
            {{productItem.app_name}}
          </a-select-option>
        </a-select>
        <a-range-picker v-model="date"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;" @change="changeDate()" />
        <a-button type="primary">导出</a-button>
      </div>
      <a-table :columns="getTableColumns" id="show-table"
               style="height: 100%;overflow-y: hidden;background: #ffffff"
               :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }"
               :data-source="tableData"
               :rowKey="item=>item.app_id" :loading="tableLoad"
               bordered :pagination="false">
        <template slot="app_id" slot-scope="text">
          <ApplicationShow :application-list="$store.getters.getAppAll" :app-id="text"></ApplicationShow>
          <!--{{text}}-->
          <!--<img v-if="recode.icon" :src="recode.icon" style="height: 40px;">-->
          <!--<span style="margin-left: 10px;">{{recode.product}}</span>-->
        </template>
        <template slot="roi" slot-scope="text">
          <span :style="{color: text===100?'#3f8600':text<100?'#cf1322':'#1890ff'}">{{ text }} %</span>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import PanelCard from "../../components/V1/PanelCard";
import {GetHomeProduct, GetHomeSummaryProduct} from "../../api/v1/home_api";
import ApplicationShow from "../../components/V1/ApplicationShow";
export default {
  name: "Product",
  components: {ApplicationShow, PanelCard},
  data(){
    return {
      product:[],
      productList:[],
      date:['',''],
      homeShowData:[],
      tableData:[],
      tableLoad:false
    }
  },
  mounted() {
    this.init_data()
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        {
          title: '产品',
          dataIndex: 'app_id',
          scopedSlots: { customRender: 'app_id' },
        },
        {
          title: '消耗',
          dataIndex: 'spend',
        },
        {
          title: '收益(广告)',
          dataIndex: 'revenue',
        },
        {
          title: 'ROI',
          dataIndex: 'roi',
          defaultSortOrder: 'descend',
          sorter: (a, b) => a.roi - b.roi,
          scopedSlots: { customRender: 'roi' },
        }
      ]
      return _table_columns
    },
  },
  filters:{
  },
  methods : {
    init_data(){
      GetHomeProduct({}).then(resp => {
        if (resp.code===200){
          Object.keys(resp.data).forEach(item=>{
            let _app = this.$store.getters.getAppAll.filter(app_item=>{
              return app_item.app_id===resp.data[item].app_id
            })
            this.homeShowData.push({
              name:resp.data[item].name,
              data:resp.data[item].data,
              suffix:item==='max_roi'?'%':'$',
              precision:2,
              img:"<img src='"+_app[0]['icon']+"' style='height: 40px;border-radius: 5px;'/>" +
                "<span style='margin-left: 10px;font-size: 18px;'>"+_app[0]['app_name']+"</span>"
            })
          })
          this.init_table_data()
        }
      })
    },
    init_table_data(){
      if (this.tableLoad) return
      this.tableLoad = true
      GetHomeSummaryProduct({product:this.product,start:this.date[0],end:this.date[1]}).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.date = resp.data.date
          this.tableData = resp.data.list
        }
      })
    },
    changeDate(){
      this.init_table_data()
    },
    changeProduct(){
      this.init_table_data()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home/Product.vue